<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Dashboard</h1>
                    <!--                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                                            <route-bread-crumb></route-bread-crumb>
                                        </nav>-->
                </div>
                <!--                <div class="col-lg-6 col-5 text-right">
                                    <base-button size="sm" type="neutral">New</base-button>
                                    <base-button size="sm" type="neutral">Filters</base-button>
                                </div>-->
            </div>
            <!-- Card stats -->
            <div class="row">
                <div class="col-xl-4" v-for="article in this.news">
                    <card>
                        <div class="card-body p-0">
                            <!-- List group -->
                            <div class="list-group list-group-flush">
                                <a target="_blank"
                                   :href="article.filename"
                                   class="list-group-item list-group-item-action flex-column align-items-start py-4 px-4">
                                    <div class="d-flex w-100 justify-content-between">
                                        <div>
                                            <div class="d-flex w-100 align-items-center">
                                                <img
                                                    src="img/brand/favicon.svg"
                                                    alt="Image placeholder"
                                                    class="avatar avatar-xs mr-2"
                                                />
                                                <h5 class="mb-1">Talus Informatik AG </h5>
                                            </div>
                                        </div>
                                        <small>{{this.getDate(article.date)}}</small>
                                    </div>
                                    <h4 class="mt-3 mb-1">{{ article.title }}</h4>
                                    <p class="text-sm mb-0">
                                        {{article.desc}}
                                    </p>
                                </a>
                            </div>
                        </div>
                    </card>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6" v-if="currentUser">
            <GridDashboard/>
        </div>
    </div>
</template>

<script>
import {computed} from "vue";
import {useStore} from 'vuex';
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import GridDashboard from "@/views/Layout/GridDashboard";
import axios from 'axios';
import BaseButton from "../../components/BaseButton.vue";

export default {
    name: "Dashboard",
    components: {
        BaseButton,
        RouteBreadCrumb,
        GridDashboard
    },
    setup() {
        const store = useStore();

        return {
            currentUser: computed(() => store.state.auth.user),
        }
    },
    data() {
        return {
            news: [],
            loading: false,
        };
    },
    methods: {
        fetchNews() {
            this.news = [];
            axios
                .get("https://www.talus.ch/format/tasks/getNews.php")
                .then((response) => {
                    const data = response.data;
                    this.news = data;
                });
        },
        getDate(date){
          let conDate = new Date(date);
          return conDate.toLocaleDateString("default", {
              day: "numeric",
              month: "long",
              year: "numeric" });
        },
    },
    created(){
        this.fetchNews()
    },
};
</script>

<style></style>
